import React, { FC, useCallback, useState } from "react";

import { useUpdatePlacesMutation } from "generated/graphql";
import { useWrapUrql } from "utils/graphql/useWrapUrql";

import { AddressStep, AddressStepProps } from "../components/AddressStep";
import { OnboardingProps } from "../models";

export interface AddressStepContainerProps extends Omit<AddressStepProps, "apiKey" | "saving"> { }

export const AddressStepContainer: FC<AddressStepContainerProps> = (props) => {

    const { onNext } = props;

    const [saving, setSavingAddress] = useState(false);

    const updatePlaces = useWrapUrql(useUpdatePlacesMutation(), {
        onSuccessMessage: "Added Business Location"
    });

    // TODO: Move to config variable
    const apiKey = "AIzaSyC5MBv-yVWy0YP4GpfsLd3JDPEBHoxzPCo";

    const handleNext = useCallback(async (createProps: OnboardingProps) => {

        setSavingAddress(true);

        const { appId, place } = createProps;

        await updatePlaces({
            appId,
            input: {
                places: [place]
            }
        });

        setSavingAddress(false);

        onNext(createProps);

    }, [onNext, updatePlaces]);

    return <AddressStep {...props} saving={saving} apiKey={apiKey} onNext={handleNext} />;
}